import styled from 'styled-components';

export const SwitchThemeContainer = styled.div`
  display: flex;
  align-items: center;

  > span {
    /* width: 32px; */
    margin-right: 8px;
    color: ${({ theme }) => theme.colors.primary};
  }

  .ant-switch-inner {
    display: grid;
    place-items: center;

    svg {
      transform: scale(1.2);
    }
  }
`;
